import { Component, Input} from '@angular/core';
import { VaccinationDocumentStatus } from '../../models/VaccinationDocument';

@Component({
    selector: 'app-vaccination-document-status',
    template: `
<span class="badge"
        [class.text-bg-light]="value == 'Draft'"
        [class.text-bg-warning]="value == 'Submitted'"
        [class.text-bg-success]="value == 'Approved'"
        [class.text-bg-danger]="value == 'Rejected'"
        [class.text-bg-dark]="value == 'Expired'">
    {{'vaccinationDocument_status' + value | translate}}
</span>
`
})
export class VaccinationDocumentStatusComponent {
    @Input() value: VaccinationDocumentStatus;
}
